import MultiTab from './multi-tab.vue'
export default MultiTab
